import type { SaveManager } from "../save/SaveManager";

export interface AchievementDef {
  id: string;
  title: string;
  description: string;
}

export const ACHIEVEMENTS: AchievementDef[] = [
  { id: "first-launch", title: "Liftoff!", description: "Launch your first rocket." },
  { id: "orbit-earth", title: "Astronaut", description: "Reach a stable Earth orbit." },
  { id: "moon-flyby", title: "Moon Shot", description: "Fly by the Moon." },
  { id: "moon-landing", title: "One Small Step", description: "Land safely on the Moon." },
  { id: "mars-flyby", title: "Red Voyager", description: "Reach Mars' sphere of influence." },
  { id: "venus-flyby", title: "Cloud Surfer", description: "Reach Venus' sphere of influence." },
  { id: "mercury-flyby", title: "Sunchaser", description: "Reach Mercury's sphere of influence." },
  { id: "safe-return", title: "Home Safe", description: "Return a crewed capsule safely to Earth." },
  { id: "solar-array", title: "Sun Powered", description: "Deploy a solar panel in space." },
];

type UnlockFn = (a: AchievementDef) => void;

export class Achievements {
  private unlocked = new Set<string>();

  constructor(readonly save: SaveManager, private readonly onUnlock: UnlockFn) {}

  async load() {
    const list = await this.save.kvGet<string[]>("unlocked", []);
    this.unlocked = new Set(list);
  }

  has(id: string) { return this.unlocked.has(id); }

  list(): (AchievementDef & { unlocked: boolean })[] {
    return ACHIEVEMENTS.map((a) => ({ ...a, unlocked: this.unlocked.has(a.id) }));
  }

  async unlock(id: string) {
    if (this.unlocked.has(id)) return;
    const def = ACHIEVEMENTS.find((a) => a.id === id);
    if (!def) return;
    this.unlocked.add(id);
    await this.save.kvSet("unlocked", [...this.unlocked]);
    this.onUnlock(def);
  }
}
